<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>
<div class="menu">
  @for (url of current().pagesLocal; track url) {
    <core-menu-image [url]="url"/>
  }
</div>

